export default __webpack_public_path__ + "static/instagram-96f25397c0e589a824fb775f9dd774da.png";